import {observable, action} from 'mobx';
import _ from 'lodash';

class McqPerformanceStore {
  @observable performances = [];
  @observable performance = {};
  @observable session = {};

  @action
  setPerformances = (performances) => {
    this.performances = performances;
  };

  @action
  setPerformance = (performance) => {
    this.performance = performance;
  };

  @action
  setPerformanceSession = (session) => {
    this.session = session;
  };

  @action
  clearPerformance = () => {
    this.performance = {};
  }

  @action
  clearPerformanceSession = () => {
    this.session = {};
  }
};

export default new McqPerformanceStore();



// WEBPACK FOOTER //
// ./src/stores/McqPerformanceStore.js